<template>
  <div class="cart_summary">
    <shipping_bar :id="'cartSummaryShippingBarwd'" v-bind="shippingBarProps"></shipping_bar>
    <h3>Subtotal</h3>
    <span v-html="$options.filters.withCurrency($options.filters.money(cartTotal))">{{ cartTotal | money }}</span>
  </div>
</template>

<script>
  export default {
    name: 'cart_summary',
    props: ['cartTotal', 'shippingBarProps'],
  }
</script>